import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import { Typography, Box, Grid } from '@mui/material';

const AboutPage = () => {
    return (
        <>
            <Box sx={{ flexGrow: 1, p: 2 }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 8 }}>
                        <Typography variant="body1">
                        GGC.me is a creator-first platform redefining live streaming.<br />
                        We empower users to start channels, stream content, and monetize through chat-driven engagement, subscriptions, and tipping—all under a unified, mobile-friendly brand.<br />
                        Think Twitch’s engagement, Patreon’s creator economy, and TikTok’s energy—built for scale, agility, and deep creator tools.<br />
                        Our domain name says it all: GGC.me—Go Get Creative.
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>

                    </Grid>
                </Grid>
            </Box>
        </>
    )
}
export default AboutPage;